import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Spinner } from '@99designs/emu';

const LoadableImageSpinnerWrapper = styled.div`
    position: relative;
    left: 50%;
    top: 50%;
    transform: translateY(-50%);
`;
const LoadableImageImg = styled.img<{ opacity: number }>`
    object-fit: scale-down;
    z-index: 11; // 1 more than our default Spinner class
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: ${({ opacity }) => opacity};
`;

interface LoadableImageProps {
    url: string;
    title: string;
}

function LoadableImage(props: LoadableImageProps) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const imageRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        if (imageRef.current) {
            setImageLoaded(imageRef.current.complete);
        } else {
            setImageLoaded(false);
        }
    }, [props.url]);

    return (
        <>
            {!imageLoaded && (
                <LoadableImageSpinnerWrapper>
                    <Spinner size="large" />
                </LoadableImageSpinnerWrapper>
            )}
            <LoadableImageImg
                ref={imageRef}
                src={props.url}
                alt={props.title}
                onLoad={() => setImageLoaded(true)}
                opacity={Number(imageLoaded)}
            />
        </>
    );
}

export default LoadableImage;
